import React from 'react';
import { styled } from '@mui/material/styles';
import { Card, CardContent, CardActions, Typography, Button } from '@mui/material';

const ProjectsContainer = styled('div')(({ theme }) => ({
  padding: theme.spacing(4),
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'space-around',
  backgroundColor: '#f5f5f5',
  color: '#333',
  margin: '1rem',
}));

const ProjectCard = styled(Card)(({ theme }) => ({
  maxWidth: 345,
  margin: theme.spacing(2),
  backgroundColor: '#fff',
  color: '#000',
  boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
  borderRadius: '20px',
  transition: 'transform 0.2s',
  '&:hover': {
    transform: 'scale(1.03)',
  },
}));

const ProjectsSection = () => {

  const projectDetails = [
    {
      title: "GitHub Activities Visualizer",
      description: "Web application to visualize different activities of the GitHub user.",
      source: "https://github.com/astromanish/git-stats",
      demo: "https://hubgit-stats.netlify.app",
    },
    {
      title: "Neural Machine Translation",
      description: "Sleek interface for real-time language translation powered by AI.",
      source: "https://github.com/astromanish/Neural-Machine-Translation",
      demo: "",
    },
    {
      title: "Liver Segmentation",
      description: "Medical imaging app for precise liver segmentation using deep learning.",
      source: "https://github.com/astromanish/als", 
      demo: "",
    },
    {
      title: "Personal Photography",
      description: "Gallery showcasing personal photography work in a minimalist layout.",
      source: "https://github.com/astromanish/Snapshots",
      demo: "",
    },
    {
      title: "Campus Compass",
      description: "Community support platform for connecting helpers with college freshers.",
      source: "https://github.com/astromanish/Campus-Compass",
      demo: "https://facha-help.netlify.app",
    },
    {
      title: "Corona Info",
      description: "Community support platform for connecting helpers with those in need of help.",
      source: "https://github.com/astromanish/Corona-care",
      demo: "https://karuna-go.netlify.app",
    },
  ];

  return (
    <ProjectsContainer id="projectsSection">
      {projectDetails.map((project, index) => (
        <ProjectCard key={project.title}>
          <CardContent>
            <Typography gutterBottom variant="h5" component="div">
              {project.title}
            </Typography>
            <Typography variant="body2" color="textSecondary">
              {project.description}
            </Typography>
          </CardContent>
          <CardActions disableSpacing>
            {/* Dynamically render Source button */}
            <Button size="small" disabled={!project.source} href={project.source} target="_blank">
              Source
            </Button>
            {/* Dynamically render Demo button */}
            <Button size="small" disabled={!project.demo} href={project.demo} target="_blank">
              Demo
            </Button>
          </CardActions>
        </ProjectCard>
      ))}
    </ProjectsContainer>
  );
};

export default ProjectsSection;
